/*
 * UIGenerator
 *
 * created by Guy Green 2017
 */

 import $ from "jquery";


class UIGenerator {
  constructor(imagesDir) {
    this.imagesDir = imagesDir;
    this.classStyles = [];
    this.styleElement = -1;
    this.registerClassStyle = function (className, styleObj) {
        var styleString = this.parseStyleObject(styleObj);
        if (this.classStyles[className]) {
            this.classStyles[className] += styleString;
        }

        this.classStyles[className] = styleString;
      };

    this.parseStyleWithSelector = function (styleObj) {
          var selector = styleObj.selector;
          return selector + "{" + this.parseStyleObject(styleObj.style) + "}";
      };
    this.injectStyleToDocument = function(styleConf) {
          var styleStringToAdd = "";
          if (this.styleElement === -1) {
              this.styleElement = document.createElement('style');
              this.styleElement.className = "UIGenerator_generated_style";
              this.styleElement.type = 'text/css';
              document.getElementsByTagName('head')[0].appendChild(this.styleElement);
          }

          if (styleConf.length) {
              for (var i = 0; i < styleConf.length; i++) {
                  styleStringToAdd += "\n" + this.parseStyleWithSelector(styleConf[i]);
              }
          }
          else {
              styleStringToAdd = this.parseStyleWithSelector(styleConf);
          }


          this.styleElement.innerHTML = this.styleElement.innerHTML + styleStringToAdd;
      };

    this.generateInput = function(inputID, inputPlaceholder, inputClass) {
          var input = "<input id='" + inputID + "' class='" + inputClass + "' placeholder='" + inputPlaceholder + "'></input>";

          return input;
      };

    this.generateFormButton = function (buttonID,  buttonText, buttonClass) {
          var button = "<div class='" + buttonClass + "' id='" + buttonID + "'>" + buttonText + "</div>";
          return button;
      };


    this.parseElementAttribute = function (attributeName, attributeValue) {
        if (typeof attributeValue === "undefined") {
            return "";
        }
        else {
            return " " + attributeName + "='" + attributeValue + "' ";
        }
      };

    this.parseStyleObject = function (styleObj) {
          if (typeof styleObj === "string") {
              return styleObj;
          }

          var styleString = "";
          for (var styleName in styleObj) {
              styleString += styleName.replace(/([A-Z])/g, "-$1").toLowerCase() + ":" + styleObj[styleName] + "; ";
          }

          return styleString;
      };

    this.parseClassNames = function (classString) {
      var classes = classString.replace(/\s+/g,' ').split(' ');
      return classes;
    };

    this.parseAttributes = function(attributes) {
        var attributesHTML = "";
        var gotStyle = false;

        var styleString = "";
        var classStyleString = "";
        for (var key in attributes) {
            var attributeName = key;
            var attributeValue = attributes[key];

            if (key === "class") {
                var classes = this.parseClassNames(attributeValue);
                for (var i = 0; i < classes.length; i++) {
                    var currentClass = classes[i];
                    if (this.classStyles[currentClass]) {
                        classStyleString += this.classStyles[currentClass];
                        gotStyle = true;
                    }
                }
            }


            if (key === "style") {
                styleString += this.parseStyleObject(attributeValue);
                gotStyle = true;
                continue;
            }

            attributesHTML += this.parseElementAttribute(attributeName, attributeValue);
        }

        if (gotStyle) {
            attributesHTML += this.parseElementAttribute('style', classStyleString + styleString);
        }

        return attributesHTML;
    };


    this.generateHTML = function(config) {
        if (typeof config.type === 'undefined') {
            config.type = 'div';
        }

        var elementType = config.type;
        var attributes = config.attributes;
        var innerHtml = config.innerHTML;

        var attributesString = "";
        if (typeof attributes !== "undefined") {
            attributesString = this.parseAttributes(attributes);
        }


        if (typeof innerHtml === "undefined") {
            innerHtml = "";
        }


        var newElement = "<" + elementType + " " + attributesString + ">" + innerHtml + "</" + elementType + ">";

        return newElement;
    };


    this.generateAndAddHTML = function(parent, elementConfig) {
        var newElement = $(this.generateHTML(elementConfig));
        parent.append(newElement);
        return newElement;
    };


    this.generateLoader = function(loaderID, loaderText, classPrefix) {
        if (typeof loaderText === "undefined") {
            loaderText = "loading...";
        }
        var loaderContainerOpen = "<div class='" + classPrefix + "_loader_container' id='" + loaderID + "'>";
        var loaderContainerClose = "</div>";


        var loaderInnerContainerOpen = "<div class='" + classPrefix + "_loader_inner_container'>";
        var loaderInnerContainerClose = "</div>";
        var loaderHTML = "<div class='" + classPrefix + "_loader_text'>" + loaderText + "</div>";
        var loaderImage = "<img class='" + classPrefix + "_loader' src='" + this.imagesDir + "timoccoJuggleAnim.gif'></img>";

        return loaderContainerOpen + loaderInnerContainerOpen + loaderImage + loaderHTML + loaderInnerContainerClose + loaderContainerClose;
    };
  }
}



export default UIGenerator;



// WEBPACK FOOTER //
// ./src/components/components/results/heatmap/UIGen.js